import { render, staticRenderFns } from "./paymentPassword.vue?vue&type=template&id=3974f5e5"
import script from "./paymentPassword.vue?vue&type=script&lang=js"
export * from "./paymentPassword.vue?vue&type=script&lang=js"
import style0 from "./paymentPassword.vue?vue&type=style&index=0&id=3974f5e5&prod&lang=less&scpoed=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports